import { useState, type ReactNode, type CSSProperties, Children } from 'react';

interface AccordionProps {
  sections: Array<{ id: string; label: string }>;
  defaultOpen?: string[];
  allowMultiple?: boolean;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function AccordionView({
  sections,
  defaultOpen = [],
  allowMultiple = false,
  className,
  style,
  children,
}: AccordionProps) {
  const [openSections, setOpenSections] = useState<Set<string>>(new Set(defaultOpen));
  const childArray = Children.toArray(children);

  function toggle(id: string) {
    setOpenSections((prev) => {
      const next = new Set(allowMultiple ? prev : []);
      if (prev.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }

  return (
    <div
      className={`flex flex-col divide-y divide-zinc-200 dark:divide-zinc-700 h-full${className ? ` ${className}` : ''}`}
      style={style}
    >
      {sections.map((section, i) => (
        <div
          key={section.id}
          className={openSections.has(section.id) ? 'flex flex-col flex-1 min-h-0' : ''}
        >
          <button
            onClick={() => toggle(section.id)}
            className="flex w-full items-center justify-between px-3 py-2 text-sm font-medium text-left text-zinc-700 hover:bg-zinc-50 dark:text-zinc-300 dark:hover:bg-zinc-800"
            aria-expanded={openSections.has(section.id)}
          >
            {section.label}
            <span
              className={`transition-transform ${openSections.has(section.id) ? 'rotate-180' : ''}`}
            >
              ▾
            </span>
          </button>
          {openSections.has(section.id) && (
            <div className="px-3 pb-3 flex flex-col flex-1 min-h-0">{childArray[i]}</div>
          )}
        </div>
      ))}
    </div>
  );
}
